<script setup lang="ts">
import { onMounted, reactive } from 'vue'

import CategoryManagePanel from '@/components/CategoryManagePanel.vue'
import store from '@/store'

import CreateTeacher from './CreateTeacher.vue'

interface AdminData {
  tab: number
}

const state = reactive<AdminData>({
  tab: 1,
})

onMounted(() => {
  store.dispatch.teacher.fetchSentenceGroupCategories()
  store.dispatch.teacher.fetchSentenceGroups({ mine: false })
})
</script>

<template>
  <v-tabs v-model="state.tab">
    <v-tab>Create teacher</v-tab>
    <v-tab>Categories</v-tab>
  </v-tabs>
  <v-window v-model="state.tab">
    <v-window-item key="0" value="0">
      <create-teacher />
    </v-window-item>
    <v-window-item key="1" value="1">
      <category-manage-panel />
    </v-window-item>
  </v-window>
</template>
